import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Form } from "@angular/forms";
import * as _ from "lodash";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { NbcLoggerService } from "../../../shared/logger/nbc-logger.service";

@Component({
    selector: "nbc-pay-transaction",
    templateUrl: "./modal-pay-transaction.component.html",
    standalone: false
})
export class ModalPayTransactionComponent implements OnInit {
    constructor(
        public bsModalRef: BsModalRef,
        private log: NbcLoggerService
    ) {}

    @Input()
    listItem: any;

    @Input()
    isBulk: any = false;

    @Input()
    payrollDefaultsList: any = [];

    @Output()
    payTransactionsChange: EventEmitter<any> = new EventEmitter<any>();

    allTransactionTypes: any = [];
    listItemClone: any;
    onSync: Subject<any>;

    isAftraRateValid = true;
    isRateValid = true;

    setAllTransactionTypes() {
        this.allTransactionTypes = this.isBulk
            ? this.listItem.contractCode.transactionTypes.filter((t) => {
                  return (t.description || "").toLowerCase() !== "olymincall";
              })
            : this.listItem.transactionTypes.filter((t) => {
                  return !(
                      t.description.toLowerCase() === "olymincall" &&
                      !!this.listItem.isApproved
                  );
              });
    }

    add() {
        this.listItemClone.payTransactions.push({
            transactionType: {
                id: null,
                description: "",
            },
            hrUnit: null,
            rate: null,
            transactionCode: null,
        });
    }

    setCode(transaction, index) {
        if (transaction) {
            transaction.transactionType = _.find(this.allTransactionTypes, {
                description: transaction.description,
            });
            transaction.transactionCode = transaction.description;
            transaction.selectedTransactionType = transaction.transactionType;
            transaction.hrUnit = null;
            transaction.rate = null;

            this.listItemClone.payTransactions[index] = transaction;
        }
    }

    addPayTransaction(payTransactionsForm: any) {
        this.log.trace("addPayTransaction");
        if (!payTransactionsForm.valid) return;

        this.listItemClone.payTransactions;

        this.listItem = this.listItemClone;
        this.onSync.next(this.listItem);
        this.bsModalRef.hide();
    }

    remove(index) {
        this.listItemClone.payTransactions.splice(index, 1);
    }

    cancel() {
        this.log.trace("cancel");
        this.bsModalRef.hide();
    }

  checkRateValidation() {

        let formattedCustomRate;
        let formattedAftraAmount;

        if (typeof this.listItem.aftraAmount === 'string') {
          formattedAftraAmount = this.listItem.aftraAmount.replace(/,/g, '');  // Remove commas if present
        }
        else {
          formattedAftraAmount = this.listItem.aftraAmount;
        }

        if (typeof this.listItem.customRate === 'string') {
          formattedCustomRate = this.listItem.customRate.replace(/,/g, '');  // Remove commas if present
        } else {
          formattedCustomRate = this.listItem.customRate;
        }

        if (((formattedAftraAmount && Number(formattedAftraAmount) > 5000) || (formattedCustomRate && Number(formattedCustomRate) > 5000)) ||
          ((formattedAftraAmount && Number(formattedAftraAmount) < 200) || (formattedCustomRate && Number(formattedCustomRate) < 200)))
        {
            this.isAftraRateValid = false;
        }
 
        if (this.listItem.payTransactions) {
            const rateList = _.filter(this.listItem.payTransactions, (o) => {
                return o.rate > 5000;
            });
            if (rateList.length > 0) {
                this.isRateValid = false;
                // $('#addEntry').attr('disabled', 'disabled');
            }
        }
    }

    checkPayrollDefault() {
        if (this.listItem.contractCode !== null) {
            const defaultListItem = _.find(this.payrollDefaultsList, {
                tkContractCode: this.listItem.contractCode.name,
            });
            if (
                defaultListItem &&
                this.listItem.contractCode.name ===
                    defaultListItem.tkContractCode &&
                defaultListItem.defaultPayTransaction !== null
            ) {
                let defaultTranscationType: any = [];
                let actualRate;
                const dividend = defaultListItem.rate.split("/")[1];
                const valTodivide = _.isNil(this.listItem.hoursWorked) ? parseInt(dividend) : parseInt(this.listItem.hoursWorked);
                let hasMultipleRate = false;

                //if (typeof this.listItem.aftraAmount === 'string') {
                //  this.listItem.aftraAmount = this.listItem.aftraAmount.replace(/,/g, '');  // Remove commas if present
                //}

                //if (typeof this.listItem.customRate === 'string') {
                //  this.listItem.customRate = this.listItem.customRate.replace(/,/g, '');  // Remove commas if present
                //}

                let formattedCustomRate;
                let formattedAftraAmount;

                if (typeof this.listItem.aftraAmount === 'string') {
                  formattedAftraAmount = this.listItem.aftraAmount.replace(/,/g, '');  // Remove commas if present
                }
                else {
                  formattedAftraAmount = this.listItem.aftraAmount;
                }

                if (typeof this.listItem.customRate === 'string') {
                  formattedCustomRate = this.listItem.customRate.replace(/,/g, '');  // Remove commas if present
                } else {
                  formattedCustomRate = this.listItem.customRate;
                }


                if (!this.isBulk) {
                    defaultTranscationType = _.find(
                        this.listItem.transactionTypes,
                        { description: defaultListItem.defaultPayTransaction }
                    );

                    if (this.listItem.aftraAmount) {
                        actualRate = formattedAftraAmount / valTodivide;
                    } else {
                      actualRate = formattedCustomRate / valTodivide;
                    }
                } else {
                    defaultTranscationType = _.find(
                        this.listItem.contractCode.transactionTypes,
                        { description: defaultListItem.defaultPayTransaction }
                    );
                    if (this.listItem.aftraAmount) {
                        actualRate = formattedAftraAmount / valTodivide;
                    } else if (this.listItem.customRate) {
                        actualRate = formattedCustomRate / valTodivide;
                    } else {
                        hasMultipleRate = true;
                    }
                }
                // logic for rate ....

                if (defaultTranscationType) {
                    this.listItemClone.payTransactions.push({
                        transactionType: {
                            id: defaultTranscationType.id,
                            description: defaultTranscationType.description,
                        },
                        hrUnit: _.isNil(this.listItem.hoursWorked) ? parseInt(defaultListItem.hrUnit) : parseInt(this.listItem.hoursWorked),
                        rate: !hasMultipleRate ? actualRate.toFixed(2) : null,
                        transactionCode: defaultTranscationType.description,
                    });
                }
            }
            else if (
              defaultListItem &&
              this.listItem.contractCode.name ===
              defaultListItem.tkContractCode &&
              defaultListItem.defaultPayTransaction == null
            ) {

              const defaultItem = _.find(this.payrollDefaultsList, {
                tkContractCode: this.listItem.contractCode.name, employeeType: null,
              });

              let defaultTranscationTypeWithoutEmpType: any = [];

              let actualRate;
              const dividend = defaultItem.rate.split("/")[1];
              const valTodivide = _.isNil(this.listItem.hoursWorked) ? parseInt(dividend) : parseInt(this.listItem.hoursWorked);
              let hasMultipleRate = false;

              let formattedCustomRate;
              let formattedAftraAmount;

              if (typeof this.listItem.aftraAmount === 'string') {
                formattedAftraAmount = this.listItem.aftraAmount.replace(/,/g, '');  // Remove commas if present
              }
              else {
                formattedAftraAmount = this.listItem.aftraAmount;
              }

              if (typeof this.listItem.customRate === 'string') {
                formattedCustomRate = this.listItem.customRate.replace(/,/g, '');  // Remove commas if present
              } else {
                formattedCustomRate = this.listItem.customRate;
              }


              if (!this.isBulk) {
                defaultTranscationTypeWithoutEmpType = _.find(
                  this.listItem.transactionTypes,
                  { description: defaultItem.defaultPayTransaction }
                );

                if (this.listItem.aftraAmount) {
                  actualRate = formattedAftraAmount / valTodivide;
                } else {
                  actualRate = formattedCustomRate / valTodivide;
                }
              } else {
                defaultTranscationTypeWithoutEmpType = _.find(
                  this.listItem.contractCode.transactionTypes,
                  { description: defaultItem.defaultPayTransaction }
                );
                if (this.listItem.aftraAmount) {
                  actualRate = formattedAftraAmount / valTodivide;
                } else if (this.listItem.customRate) {
                  actualRate = formattedCustomRate / valTodivide;
                } else {
                  hasMultipleRate = true;
                }
              }


              if (defaultTranscationTypeWithoutEmpType) {
                this.listItemClone.payTransactions.push({
                  transactionType: {
                    id: defaultTranscationTypeWithoutEmpType.id,
                    description: defaultTranscationTypeWithoutEmpType.description,
                  },
                  hrUnit: _.isNil(this.listItem.hoursWorked) ? parseInt(defaultItem.hrUnit) : parseInt(this.listItem.hoursWorked),
                  rate: !hasMultipleRate ? actualRate.toFixed(2) : null,
                  transactionCode: defaultTranscationTypeWithoutEmpType.description,
                });
              }


              /*defaultTranscationTypeWithoutEmpType = _.find(
                this.isBulk ? this.listItem.contractCode.transactionTypes : this.listItem?.transactionTypes,
                { description: defaultItem.defaultPayTransaction }
              );

              if (defaultTranscationTypeWithoutEmpType) {
                this.listItemClone.payTransactions.push({
                  transactionType: {
                    id: defaultTranscationTypeWithoutEmpType.id,
                    description: defaultTranscationTypeWithoutEmpType.description,
                  },
                  hrUnit: null,
                  rate: null,
                  transactionCode: defaultTranscationTypeWithoutEmpType.description,
                });
              }*/

            }
            else {
                this.listItemClone.payTransactions = [];
                this.add();
            }
        } else {
            this.listItemClone.payTransactions = [];
            this.add();
        }
    }

    checkPayTransactionRate(rate) {
        if (rate && rate > 5000) {
            this.isRateValid = false;
            //$('#addEntry').attr('disabled', 'disabled');
        } else {
            this.isRateValid = true;
            //$('#addEntry').prop('disabled', false);
        }
    }

    initData() {
        this.listItemClone = _.cloneDeep(this.listItem);
        if (this.isBulk && !_.has(this.listItemClone, "payTransactions")) {
            _.assign(this.listItemClone, { payTransactions: [] });
        }
        if (_.isEmpty(this.listItemClone.payTransactions)) {
            this.checkPayrollDefault();
        }
        this.checkRateValidation();
        this.setAllTransactionTypes();
        _.forEach(this.listItemClone.payTransactions, (pt) => {
            if (!_.isEmpty(pt.transactionType?.description))
                pt.selectedTransactionType = pt.transactionType;
        });
    }

    ngOnInit() {
        this.onSync = new Subject<any>();
        this.initData();
    }
}
